<template>
  <v-main>
    <v-container>
      <v-img src="../assets/组1.png">
        <div
            class="pa-4 mt-10">
          <img src="../assets/logo.png" width="100" class="ml-4">
          <v-card-title class="text-h5 mb-4">
            <v-row>
              <v-col>
                <span class="font-weight-bold" style="color: rgb(0, 0, 0);">资料下载</span>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <p class="text-subtitle-1" style="color: rgb(134, 139, 139);">
              关注飞卓科技，持续更新中...
            </p>
          </v-card-text>
        </div>
      </v-img>
      <div align="center" style="border-radius:20px 20px 0 0;">
        <!-- 按钮区域 -->
        <div class="mt-16">
          <!-- 继续填报按钮   href="../files/石油化工宣传册.pdf"  download="石油化工宣传册.pdf"-->
          <v-btn color="#50c0be"

                 href="http://47.103.101.21:8096/wenjian/%E5%85%89%E4%BC%8F%E8%A1%8C%E4%B8%9A%E5%AE%A3%E4%BC%A0%E5%86%8C.pdf"
                 download="飞卓光伏行业宣传册.pdf" style="border: 1px #50c0be solid; width: 80%">下载光伏行业宣传册
          </v-btn>
        </div>
        <div>
          <v-btn href="http://47.103.101.21:8096/wenjian/FVG%E9%87%91%E5%B1%9E%E8%96%84%E8%86%9C%E7%9C%9F%E7%A9%BA%E8%AE%A1.pdf" download="飞卓FVG金属薄膜真空计宣传册.pdf" class="mt-4"
                 color="#50c0be" elevation="0" style="border: 1px #50c0be solid; width: 80%;">下载FVG金属薄膜真空计宣传册

          </v-btn>
        </div>
        <div>
          <v-btn href="http://47.103.101.21:8096/wenjian/%E7%AE%A1%E5%A4%B9%E5%BC%8F%E8%B6%85%E5%A3%B0%E6%B5%81%E9%87%8F%E4%BC%A0%E6%84%9F%E5%99%A8.pdf" download="飞卓UM管夹式超声流量传感器宣传册.pdf" class="mt-4"
                 color="#50c0be" elevation="0" style="border: 1px #50c0be solid; width: 80%;">下载FUM管夹式超声流量传感器宣传册

          </v-btn>
        </div>
        <div>
          <v-btn href="http://47.103.101.21:8096/wenjian/LLM-A10%20%E6%BF%80%E5%85%89%E6%B6%B2%E4%BD%8D%E8%AE%A1.pdf" download="飞卓LLM-A10激光液位计宣传册.pdf" class="mt-4"
                 color="#50c0be" elevation="0" style="border: 1px #50c0be solid; width: 80%;">下载LLM-A10激光液位计宣传册

          </v-btn>
        </div>
        <div>
          <v-btn          href="http://47.103.101.21:8096/wenjian/FEEJOY%E4%BC%81%E4%B8%9A%E5%AE%A3%E4%BC%A0%E5%86%8C.pdf" download="FEEJOY 企业宣传册.pdf" class="mt-4"
                 color="#50c0be" elevation="0" style="border: 1px #50c0be solid; width: 80%;">下载FEEJOY 企业宣传册
          </v-btn>
        </div>
        <!-- 完成按钮  -->
<!--        <div>-->
<!--          <v-btn-->
<!--              href="http://47.103.101.21:8096/wenjian/%E5%8D%8A%E5%AF%BC%E4%BD%93%E8%A1%8C%E4%B8%9A%E5%AE%A3%E4%BC%A0%E5%86%8C20250320.pdf"-->
<!--              download="半导体行业宣传册.pdf" class="mt-4" color="#50c0be" elevation="0"-->
<!--              style="border: 1px #50c0be solid; width: 80%;">下载半导体行业宣传册-->
<!--          </v-btn>-->
<!--        </div>-->
        <div>
          <v-btn
              href="http://47.103.101.21:8096/wenjian/%E7%9F%B3%E6%B2%B9%E5%8C%96%E5%B7%A5%E5%AE%A3%E4%BC%A0%E5%86%8C.pdf"
              download="石油化工宣传册.pdf" class="mt-4" color="#50c0be" elevation="0"
              style="border: 1px #50c0be solid; width: 80%;">下载石油化工宣传册
          </v-btn>
        </div>

        <div>
          <v-btn href="https://wenjian.feejoy.com/%E5%8D%8A%E5%AF%BC%E4%BD%9320251208.pdf" download="飞卓半导体行业宣传册.pdf" class="mt-4" color="#50c0be"
                 elevation="0" style="border: 1px #50c0be solid; width: 80%;">下载半导体行业宣传册
          </v-btn>
        </div>

        <div>
          <v-btn href="http://47.103.101.21:12017/飞卓液冷宣传册251225.pdf" download="飞卓液冷宣传册.pdf" class="mt-4"
                 color="#50c0be" elevation="0" style="border: 1px #50c0be solid; width: 80%;">下载液冷行业宣传册
          </v-btn>
        </div>


      </div>
    </v-container>
  </v-main>
</template>

<script>
export default {
  // 展示点击下载资料页面
  name: "means",
  data() {

  },
  methods: {
    // 点击触发函数进行下载文件 
    // downloadFile() {  
    //   const link = document.createElement('a');  
    //   link.href = '';     // 替换为你的文件路径  
    //   link.download = 'FEEJOY石砂浆工宣传册.pdf';    // 替换为你想要保存的文件名  
    //   link.click();  
    // }, 
    // 点击异步事件触发函数进行下载文件
    // async downloadFile() {  
    //   try {  
    //     const url = '../files/石油化工宣传册.pdf'; // 替换为你的文件URL  
    //     const response = await fetch(url);  
    //     if (!response.ok) {  
    //       throw new Error('下载失败');  
    //     }  
    //     const blob = await response.blob();  
    //     const downloadUrl = window.URL.createObjectURL(blob);  
    //     const a = document.createElement('a');  
    //     a.href = downloadUrl;  
    //     a.download = '石油化工宣传册.pdf'; // 替换为你的文件名  
    //     document.body.appendChild(a);  
    //     a.click();  
    //     window.URL.revokeObjectURL(downloadUrl);  
    //     document.body.removeChild(a);  
    //   } catch (error) {  
    //     console.error('下载错误:', error);
    //   }  
    // } 
  }
}
</script>
